"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builtInConfigs = void 0;
const recommended_1 = require("./recommended");
const all_1 = require("./all");
const minimal_1 = require("./minimal");
exports.builtInConfigs = {
    recommended: recommended_1.default,
    minimal: minimal_1.default,
    all: all_1.default,
    'redocly-registry': {
        decorators: { 'registry-dependencies': 'on' }
    }
};
